import {Form, Formik} from 'formik';
import Header from 'modules/header/farm/main';
import {initialValues} from './utilities/initialValues';
import {Schema} from './utilities/validationSchema';
import {useFarm} from 'context/farmContext';
import usePostAd from '../../hooks/usePostAd';
import {formDataCreator} from '../../utilities/formDataCreatot';
import SimpleFormComponent from 'components/forms/simple';
import useSetAnswers from './hooks/useSetAnswers';
import {useState} from 'react';
import {googleAnalyticsInstance} from 'utilities/helper/googleAnalitics';
import {FarmEvents} from 'utilities/helper/googleAnalitics/EventHelper';

const SimpleForm = () => {
  const {farm} = useFarm();
  const {isLoading, mutate} = usePostAd();
  const {answers, handleAnswers} = useSetAnswers();
  const [isChecked, setIsChecked] = useState<boolean>(false);
  return (
    <>
      <Header title="ثبت آگهی" />
      <Formik
        initialValues={initialValues}
        validationSchema={Schema}
        onSubmit={values => {
          const payload = new FormData();
          formDataCreator(payload, farm);
          values?.negotiated_price &&
            payload.append('negotiated_price', `${values?.negotiated_price}`);
          !values?.negotiated_price && payload.append('price', values.price);
          if (answers.length > 0) {
            const answersGuid: string[] = [];
            answers.map(item => answersGuid.push(item.guid));
            payload.append('answers', answersGuid.toString());
          }
          !isLoading && mutate(payload);
          googleAnalyticsInstance.eventGoogleAnalytics(FarmEvents.addedSimple);
        }}
      >
        {({values}) => (
          <Form className="mt-8 px-3 pb-4">
            <SimpleFormComponent
              values={values}
              isLoading={isLoading}
              subProduct={farm?.subProduct}
              handleAnswers={handleAnswers}
              answers={answers}
              isChecked={isChecked}
              setIsChecked={setIsChecked}
            />
          </Form>
        )}
      </Formik>
    </>
  );
};

export default SimpleForm;
